<template>
  <div class="tools-node-edit">
    <Card shadow class="content">
      <div class="main">
        <Row class="title">
          <h4 :style="{float: 'left'}">{{ $route.params.id ? '编辑节点' : '添加节点' }}</h4>
        </Row>
        <Form inline :label-width="100" :rules="baseInfoFormRules" ref="baseInfo" :model="baseInfo">
          <Row>
            <FormItem label="名称" style="width: 100%" prop="name">
              <Input :maxlength="100" v-model="baseInfo.name" placeholder="请填写节点名称2"/>
            </FormItem>
            <FormItem label="URL" style="width: 100%" prop="url">
              <Input :maxlength="512" v-model="baseInfo.url" placeholder="如：http://10.1.1.193:9008 "/>
              <Alert show-icon type="warning">SVN填写svn服务器上部署的api服务地址 / GIT填写git访问地址</Alert>
            </FormItem>
            <FormItem label="版本库类型" style="width: 100%" >
              <RadioGroup v-model="baseInfo.type" @on-change="onSelectChange">
                <Radio label="svn">SVN</Radio>
                <Radio label="git">GIT</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="Token" prop="token" style="width: 100%" v-show="isTokenShow">
              <Input v-model="baseInfo.token" :maxlength="500" placeholder="连接Token" type="password" />
            </FormItem>
          </Row>
        </Form>
      </div>
      <div style="text-align: center;">
        <Button type="primary" style="margin-right: 10px" :loading="submitting" @click="submit">提交</Button>
        <Button @click="$router.go(-1)">取消</Button>
      </div>
    </Card>
  </div>
</template>

<script>
import { changeNode, detailNode } from '@/api/tools/gitlab'
export default {
  name: 'edit',
  data () {
    return {
      isTokenShow: true,
      baseInfo: {
        id: '',
        name: '',
        url: '',
        type: 'svn',
        token: ''
      },
      baseInfoFormRules: {
        name: { required: true, message: '节点名称不能为空', trigger: 'blur' },
        url: { required: true, message: 'URL不能为空', trigger: 'blur' }
      },
      submitting: false
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    onSelectChange (value) {
      if (value === 'svn') {
        this.isTokenShow = false
      } else {
        this.isTokenShow = true
      }
    },
    // 初始化
    init () {
      if (this.$route.params.id) {
        this.getData()
      } else {
        this.onSelectChange('svn')
      }
    },
    getData () {
      detailNode(this.$route.params.id).then(res => {
        for (let i in this.baseInfo) {
          this.baseInfo[i] = res.data[i]
        }
        this.onSelectChange(this.baseInfo.type)
      })
    },
    submit () {
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          this.submitting = true
          changeNode(this.baseInfo, this.baseInfo.id).then(res => {
            this.$Notice.success({
              title: '操作成功'
            })
            this.$router.push({name: 'tools_node'})
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        } else {
          this.$Notice.warning({
            title: '请检查表单！'
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  @import '../../base.less';
</style>
